import { fetchPublicKey } from "../API/UserApi";

export const encryptPassword = async (password) => {
  const publicKeyResponse = await fetchPublicKey();
  const publicKeyBase64 = publicKeyResponse.data.publicKey;

  const cleanedKey = publicKeyBase64
    .replace(/-----BEGIN PUBLIC KEY-----/, "")
    .replace(/-----END PUBLIC KEY-----/, "")
    .replace(/\s/g, "");

  const binaryKey = Uint8Array.from(atob(cleanedKey), (c) => c.charCodeAt(0));
  const cryptoKey = await crypto.subtle.importKey(
    "spki",
    binaryKey,
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"],
  );

  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    cryptoKey,
    new TextEncoder().encode(password),
  );

  return btoa(String.fromCharCode(...new Uint8Array(encryptedBuffer)));
};
